import { useContext } from 'react';
import { AuthContext } from '../context/AuthContext';

/**
 * Droits de l'utilisateur sur les lots attribués (lot 057).
 *
 * - `peutEcrire` : droit d'écriture sur le module (profil Personnel compris,
 *   anciens comptes Logistique) ; hors fournisseur d'authentification (tests),
 *   l'écran reste utilisable. Le serveur refuse de toute façon une écriture sans droit.
 * - `voitArgent` : le prix au litre n'est saisi et lu que par qui voit les
 *   montants ; le serveur n'envoie le prix qu'à ceux-là.
 */
export function useDroitsLots() {
  const auth = useContext(AuthContext);
  const peutEcrire =
    !auth ||
    (typeof auth.canWriteModule === 'function' && auth.canWriteModule('lots')) ||
    auth.user?.role === 'LOGISTIQUE';
  const voitArgent = Boolean(auth && auth.canSeeMoney === true);
  return { peutEcrire, voitArgent };
}

export default useDroitsLots;
